import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import request from "../../qnb/api/request";
export function getImmediateQuoteMain(_x) { return _getImmediateQuoteMain.apply(this, arguments); }
function _getImmediateQuoteMain() { _getImmediateQuoteMain = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(data) { var _data$discountCodes; var resp; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            data.discountCodes = (_data$discountCodes = data.discountCodes) !== null && _data$discountCodes !== void 0 ? _data$discountCodes : "";
            _context.next = 3;
            return request.post("/api/v1/quotation/quoteMain/immediateQuote", Object.assign({}, data, { useSubmitTime: true }));
        case 3:
            resp = _context.sent;
            return _context.abrupt("return", resp.data);
        case 5:
        case "end": return _context.stop();
    }
} }, _callee); })); return _getImmediateQuoteMain.apply(this, arguments); }
export function getCustomerPrefillInfo() { return _getCustomerPrefillInfo.apply(this, arguments); }
function _getCustomerPrefillInfo() { _getCustomerPrefillInfo = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee2() { var resp; return _regeneratorRuntime.wrap(function _callee2$(_context2) { while (1) {
    switch (_context2.prev = _context2.next) {
        case 0:
            _context2.next = 2;
            return request.post("/api/v1/quotation/getCustomerPrefillInfo", { useSubmitTime: true });
        case 2:
            resp = _context2.sent;
            return _context2.abrupt("return", resp.data);
        case 4:
        case "end": return _context2.stop();
    }
} }, _callee2); })); return _getCustomerPrefillInfo.apply(this, arguments); }
